import { api } from '../../../lib/api'

export const TOGGLE_CTA_REQUEST = 'TOGGLE_CTA_REQUEST'
export const TOGGLE_CTA_SUCCESS = 'TOGGLE_CTA_SUCCESS'
export const TOGGLE_CTA_FAILED = 'TOGGLE_CTA_FAILED '

export const toggleCTA = function (productId, ctaType) {
    return function (dispatch) {
        dispatch({
            type: TOGGLE_CTA_REQUEST
        })

        switch (ctaType) {
            case 'download':
                api.toggleAllowDownload(productId).then(toggleCTAResponse => {
                    dispatch({
                        type: TOGGLE_CTA_SUCCESS,
                        payload: toggleCTAResponse
                    })
                }).catch(error => {
                    dispatch({
                        type: TOGGLE_CTA_FAILED,
                        error
                    })
                })
                break;
            case 'featured':
                api.toggleFeatured(productId).then(toggleCTAResponse => {
                    dispatch({
                        type: TOGGLE_CTA_SUCCESS,
                        payload: toggleCTAResponse
                    })
                }).catch(error => {
                    dispatch({
                        type: TOGGLE_CTA_FAILED,
                        error
                    })
                })
                break;
            case 'favourite':
                api.toggleAllowFavourite(productId).then(toggleCTAResponse => {
                    dispatch({
                        type: TOGGLE_CTA_SUCCESS,
                        payload: toggleCTAResponse
                    })
                }).catch(error => {
                    dispatch({
                        type: TOGGLE_CTA_FAILED,
                        error
                    })
                })
                break;
            case 'share':
                api.toggleAllowShare(productId).then(toggleCTAResponse => {
                    dispatch({
                        type: TOGGLE_CTA_SUCCESS,
                        payload: toggleCTAResponse
                    })
                }).catch(error => {
                    dispatch({
                        type: TOGGLE_CTA_FAILED,
                        error
                    })
                })
                break;
            default:
                break;
        }

    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/product/toggle-cta.js